<template>
  <modal-template
    :open="open"
    showLogo
    :secondaryBtnProps="{
      show: true,
      text: 'Ir al tablero',
      color: 'accent',
      textColor: 'white',
    }"
    @close="$emit('close')"
  >
    <template #content>
      <div
        class="d-flex flex-column align-center text-h5 font-weight-bold text-center"
      >
        <p class="mt-5">Gracias!</p>
        <p>Hemos abonado {{ balance }} registros nuevos a tu tablero.</p>
        <v-icon size="150" :color="color.primary"> mdi-check-bold </v-icon>
        <p class="text-subtitle-1 font-weight-medium invoice-text">
          *Utilizando el id <b>{{ purchaseId }}</b> Puedes generar, visualizar y
          descargar la factura de tu compra haciendo click
          <a
            :href="`/facturacion-cliente/${purchaseId}`"
            :style="`text-decoration: none; color: ${color.primaryVariant}`"
            @click="$emit('close')"
            >Aquí</a
          >
        </p>
        <p>
          Recuerda que tienes hasta finalizar el mes para generar tu factura.
        </p>
      </div>
    </template>
  </modal-template>
</template>
<script>
import ModalTemplate from "@/components/shared/ModalTemplate";
import { colors } from "@/constants/colors.js";

export default {
  components: {
    ModalTemplate,
  },
  data() {
    return {
      color: colors,
    };
  },
  props: ["open", "balance", "purchaseId"],
};
</script>
<style scoped>
.invoice-text {
  width: 75%;
}
.link-btn {
  cursor: pointer;
  text-decoration: none;
}
</style>
